export default "__VITE_ASSET__BzqmaF5u__"